import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as affiliate from '../affiliate'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: affiliate.RESOURCE.payload.dimension.partialId,
      partialId: affiliate.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Year affiliate was founded',
    isOptional: true,
    name: 'Years in Operation',
    partialId: PartialId.Standard.create('years_in_operation'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
